import { FC, useId } from "react";

// Inline SVG flags: emoji flags do not render on Windows. 3:2 viewBox, drawn at 20×14 next to the label.
type FlagProps = { title?: string };

// Decorative next to the language name: hidden from assistive tech unless a title names it.
const a11y = (title?: string) => (title ? { "aria-label": title } : { "aria-hidden": true });

const size = { width: 20, height: 14, viewBox: "0 0 30 20", role: "img" as const, style: { flexShrink: 0 } };

export const FlagGB: FC<FlagProps> = ({ title }) => {
  // The flag renders several times on a page (selected value + options): each copy needs its own clip id.
  // useId may contain characters (":", "«") that break a url(#…) reference, so keep only safe ones.
  const clipId = `flag-gb-${useId().replace(/[^a-zA-Z0-9_-]/g, "")}`;
  return (
    <svg {...size} {...a11y(title)}>
      <clipPath id={clipId}>
        <path d="M0 0v20h30V0z" />
      </clipPath>
      <g clipPath={`url(#${clipId})`}>
        <path d="M0 0v20h30V0z" fill="#012169" />
        <path d="M0 0l30 20m0-20L0 20" stroke="#fff" strokeWidth="4" />
        <path d="M0 0l30 20m0-20L0 20" stroke="#C8102E" strokeWidth="2" />
        <path d="M15 0v20M0 10h30" stroke="#fff" strokeWidth="6" />
        <path d="M15 0v20M0 10h30" stroke="#C8102E" strokeWidth="4" />
      </g>
    </svg>
  );
};

export const FlagDE: FC<FlagProps> = ({ title }) => (
  <svg {...size} {...a11y(title)}>
    <path fill="#000" d="M0 0h30v6.67H0z" />
    <path fill="#DD0000" d="M0 6.67h30v6.66H0z" />
    <path fill="#FFCE00" d="M0 13.33h30V20H0z" />
  </svg>
);

export const FlagFR: FC<FlagProps> = ({ title }) => (
  <svg {...size} {...a11y(title)}>
    <path fill="#002395" d="M0 0h10v20H0z" />
    <path fill="#fff" d="M10 0h10v20H10z" />
    <path fill="#ED2939" d="M20 0h10v20H20z" />
  </svg>
);

export const FlagIT: FC<FlagProps> = ({ title }) => (
  <svg {...size} {...a11y(title)}>
    <path fill="#009246" d="M0 0h10v20H0z" />
    <path fill="#fff" d="M10 0h10v20H10z" />
    <path fill="#CE2B37" d="M20 0h10v20H20z" />
  </svg>
);
